import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageActionsButton = ({
  buttonIcon: Icon,
  onClick,
  tooltipProps,
  disabled,
  'data-test-id': dataTestId = 'message-actions-button'
}) => {
  return /*#__PURE__*/_jsx(IconButton, {
    use: "transparent",
    size: "md",
    onClick: onClick,
    "data-test-id": dataTestId,
    disabled: disabled,
    tooltipProps: tooltipProps,
    marginInlineStart: "0",
    paddingBlock: "0",
    paddingInline: "0",
    children: /*#__PURE__*/_jsx(Icon, {})
  });
};
MessageActionsButton.displayName = 'MessageActionsButton';
export default MessageActionsButton;